export default __webpack_public_path__ + "static/media/a' ceannachd.8e15bdfa.mp3";